const axios = require('../common/axios')
const Toast = require('../common/toast');
const WochentageTemplate = require('./wochentage.hbs');
const {format, parseISO} = require('date-fns');
const {de} = require('date-fns/locale');
const Modal = require('../common/modal');
const {FormValidator} = require("../common/form-validator");

function showProgress(element) {
	element.classList.remove('hidden');
	return Promise.resolve();
}

function hideProgress(element) {
	element.classList.add('hidden');
}

function mapWeekday(raw) {
	return {
		...raw,
		value: format(parseISO(raw.value), 'EEEEEE, dd.MM.yyyy', {locale: de})
	}
}

function loadWeekdays(progress, container) {
	return showProgress(progress).then(
		() => axios.get('/api/zwe/wochentage')
	).then(
		(response) => response.data.map(mapWeekday)
	).then(
		(data) => container.innerHTML = WochentageTemplate(data)
	).catch(
		(error) => {
			console.error('error loading weekdays', error);
			Toast.add('error', 'Wochentage konnte nicht geladen werden.');
		}
	).finally(
		() => hideProgress(progress)
	)
}

function deleteWeekday(progress, container, id) {
	return showProgress(progress).then(
		() => axios.delete(`/api/zwe/wochentage/${id}`)
	).then(
		() => loadWeekdays(progress, container)
	).finally(
		() => hideProgress(progress)
	)
}

function addFormValidityChanged(valid) {
	document.querySelectorAll('#dialogAdd [data-confirm-modal]').forEach(
		confirm => {
			confirm.disabled = !valid;
		}
	)
}

function addWeekday(progress, container, body) {
	return showProgress(progress).then(
		() => axios.put('/api/zwe/wochentage', body)
	).then(
		() => loadWeekdays(progress, container)
	).catch(
		(error) => console.error(error)
	).finally(
		() => hideProgress(progress)
	);
}

function Vergabezeitraum() {
	const progress = document.querySelector('#progress-weekdays');
	const container = document.querySelector('#container-weekday-list');
	const confirmTarget = document.querySelector('#dialogConfirm');
	const addTarget = document.querySelector('#dialogAdd');

	loadWeekdays(progress, container);

	return {
		add: () => {
			const validator = new FormValidator('#dialogAdd form', addFormValidityChanged);
			Modal.create(addTarget, {
				onConfirm: () => {
					if (validator.validate()) {
						addWeekday(progress, container, validator.getCurrentFormValue());
					}
				}
			})
		},
		delete: (id, value, event) => {
			confirmTarget.querySelector('.value').innerHTML = value;
			Modal.create(confirmTarget, {
				onConfirm: () => {
					deleteWeekday(progress, container, id)
				}
			});
			event.preventDefault();
		}
	}
}

module.exports = Vergabezeitraum;
